import { SvgIconType } from './svg.interface';

const ArrowDown: SvgIconType = ({
  width = 10,
  height = 10,
  className = '',
  color = '#0D7EB7'
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.49457 3.30823C8.73887 3.06392 9.13497 3.06392 9.37927 3.30823C9.62358 3.55253 9.62358 3.94863 9.37927 4.19293L5.44194 8.13026C5.19786 8.37434 4.80214 8.37434 4.55806 8.13026L0.620728 4.19293C0.376424 3.94863 0.376424 3.55253 0.620728 3.30823C0.865031 3.06392 1.26113 3.06392 1.50543 3.30823L5 6.8028L8.49457 3.30823Z"
      fill={color}
    />
  </svg>
);

export default ArrowDown;
